<div class="bloco-card">
  <div class="bloco-topo">
    <div class="bloco-topo-info">
      <span class="bloco-icone bloco-icone--rede">
        <mat-icon aria-hidden="true">insights</mat-icon>
      </span>
      <div class="bloco-textos">
        <h3 class="bloco-title">Status da rede</h3>
        <p class="bloco-sub">Novidades dos últimos 7 dias</p>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading; else skeleton">
    <ul class="secao-lista">
      <li class="linha-empresa" *ngIf="novasObrasVinculadas > 0" (click)="irParaCarteiraEmpresas()">
        <span class="linha-empresa-icone">
          <mat-icon aria-hidden="true">notifications</mat-icon>
        </span>
        <span class="linha-empresa-texto">
          <strong>{{ novasObrasVinculadas }}</strong>
          {{ novasObrasVinculadas === 1 ? 'nova obra vinculada' : 'novas obras vinculadas' }}
          a empresas da sua carteira
        </span>
      </li>

      <li *ngFor="let item of atualizacoesRelevantes">
        <span class="linha-num">{{ item.total }}</span>
        <span class="linha-texto">novas obras em {{ item.descricao }}</span>
      </li>

      <li *ngIf="atualizacoesRelevantes.length === 0 && novasObrasVinculadas === 0" class="empty">
        Nenhuma atualização encontrada.
      </li>
    </ul>
  </ng-container>

  <ng-template #skeleton>
    <div class="skeleton-lista">
      <div class="skeleton-item" *ngFor="let i of [1,2,3,4,5,6]"></div>
    </div>
  </ng-template>
</div>